{
  "tabs": {
    "info": "معلومات",
    "events": "الأحداث",
    "schedule": "الجدول",
    "matches": "المباريات",
    "players": "اللاعبون",
    "stats": "الإحصائيات"
  },
  "players": {
    "name": "الاسم",
    "country": "البلد",
    "events": "الأحداث",
    "rank": "الترتيب",
    "noParticipants": "لا يوجد مشاركون"
  },
  "schedule": {
    "court": "الملعب",
    "time": "الوقت",
    "event": "حدث",
    "round": "جولة",
    "matchUp": "مباراة"
  },
  "display": {
    "label": "العرض",
    "columns": "أعمدة",
    "draw": "القرعة",
    "tableView": "عرض الجدول",
    "statistics": "الإحصائيات"
  },
  "theme": {
    "toggleDark": "تبديل الوضع الداكن"
  },
  "language": {
    "select": "اختر اللغة"
  }
}
